export let APP_SETTINGS = {
    version: '',
    company: 'Brewers'
};
